import { core } from '../icelib-material';

export { default as Emitter } from './Emitter';
export { default as ExtState } from './ExtState';
export { default as Magma } from './magma';
// export { default as tools } from './tools';

export const {
    ChatHistory,
    Dictionary,
    EventsAdvance,
    EventsManager,
    FormControl,
    PubSubManager,
    Routing,
    simpleRender
} = core;